export enum DeviceMatcher {
    MOBILE = 'mobile',
    DESKTOP = 'desktop'
}

export default class ClickEventTargetManager {
    readonly #mediaQuery = {
        [DeviceMatcher.MOBILE]: '(max-width: 1023px)',
        [DeviceMatcher.DESKTOP]: '(min-width: 1024px)'
    };

    readonly #roleName: string;

    readonly #deviceMatcher: DeviceMatcher;

    readonly #listenerMap: WeakMap<HTMLElement, (e: Event) => void> = new WeakMap();

    #elements: HTMLElement[] = [];

    set targetElement(element: HTMLElement | Document) {
        this.#cleanupEventListeners();
        this.#elements = Array.from(element.querySelectorAll(`[data-role="${this.#roleName}"]`));
        this.#addEventListeners();
    }

    public constructor(roleName: string, deviceMatcher: DeviceMatcher = DeviceMatcher.MOBILE) {
        this.#roleName = roleName;
        this.#deviceMatcher = deviceMatcher;

        this.targetElement = document;
    }

    #cleanupEventListeners(): void {
        for (const element of this.#elements) {
            const handler = this.#listenerMap.get(element);
            if (handler) {
                element.removeEventListener('click', handler, true);
                this.#listenerMap.delete(element);
            }
        }
    }

    #addEventListeners(): void {
        for (const element of this.#elements) {
            const handler = (e: Event): void => this.handleEvent(e, element);
            this.#listenerMap.set(element, handler);
            element.addEventListener('click', handler, true);
        }
    }

    #changeLocationHref(element: HTMLElement): void {
        if (element.tagName !== 'A') {
            return;
        }

        window.location.href = (<HTMLAnchorElement>element).href;
    }

    protected handleEvent(event: Event, element: HTMLElement): void {
        if (!window.matchMedia(this.#mediaQuery[this.#deviceMatcher]).matches) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        this.#changeLocationHref(element);
    }
}
